const data = [
    {
        id: 1,
        sender: 'David Lee',
        userAvatar: 'https://thumb1.shutterstock.com/display_pic_with_logo/3671573/723643036/stock-photo-business-man-a-black-man-button-his-jacket-on-a-light-background-723643036.jpg',
        sent: '2020-09-23 00:00:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.'
    },
    {
        id: 2,
        sender: 'David Lee',
        sent: '2020-09-22 12:00:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb7.shutterstock.com/display_pic_with_logo/3671573/723077854/stock-photo-business-man-black-man-in-a-white-shirt-on-isolated-background-723077854.jpg',
    },
    {
        id: 3,
        sender: 'David Lee',
        sent: '2020-09-21 00:00:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb7.shutterstock.com/display_pic_with_logo/156673/674799844/stock-photo-satisfying-call-young-black-businessman-in-casual-has-mobile-phone-talk-in-modern-white-office-674799844.jpg',
    },
    {
        id: 4,
        sender: 'David Lee',
        sent: '2020-09-23 06:50:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        // userAvatar:
        // 'https://thumb1.shutterstock.com/display_pic_with_logo/76219/207792106/stock-photo-handsome-businessman-frowning-at-camera-in-his-office-207792106.jpg',
    },
    {
        id: 5,
        sender: 'David Lee',
        sent: '2020-09-23 22:10:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb9.shutterstock.com/display_pic_with_logo/2670070/503436898/stock-photo--african-american-businessman-smiling-503436898.jpg',
    },
    {
        id: 6,
        sender: 'David Lee',
        sent: '2020-09-23 10:11:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb9.shutterstock.com/display_pic_with_logo/2717350/741158365/stock-photo-smiling-black-businesswoman-with-arms-crossed-741158365.jpg',
    },
    {
        id: 7,
        sender: 'David Lee',
        sent: '2020-09-23 10:11:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb9.shutterstock.com/display_pic_with_logo/2717350/741158365/stock-photo-smiling-black-businesswoman-with-arms-crossed-741158365.jpg',
    },
    {
        id: 8,
        sender: 'David Lee',
        sent: '2020-09-23 10:11:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb9.shutterstock.com/display_pic_with_logo/2717350/741158365/stock-photo-smiling-black-businesswoman-with-arms-crossed-741158365.jpg',
    },
    {
        id: 9,
        sender: 'David Lee',
        sent: '2020-09-23 10:11:23',
        content: 'Accepted Mercedes-benz "Wonderland" Script Supervisor position for 23 Aug 2020 at 5:00 PM.',
        userAvatar:
        'https://thumb9.shutterstock.com/display_pic_with_logo/2717350/741158365/stock-photo-smiling-black-businesswoman-with-arms-crossed-741158365.jpg',
    }
];

export default data;